import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  buttonIcon: {
    marginRight: theme.spacing(0.75),
  },

  title: {
    fontWeight: theme.fontWeight.semiBold,
    fontSize: theme.fontSize.md,
    margin: 0,
  },

  iconButton: {
    padding: 0,
  },
}));
